export function useTeamCard() {
  function TeamCard(tc) {
    if (!(tc instanceof Element)) return;

    const dialog = tc.querySelector(".team-member-card__dialog");
    const showButton = tc.querySelector(".team-member-card__button");
    const closeButton = tc.querySelector(".team-member-card__dialog button");

    // "Show the dialog" button opens the dialog modally
    showButton.addEventListener("click", (e) => {
      // e.preventDefault();
      dialog.showModal();
    });

    // "Close" button closes the dialog
    closeButton.addEventListener("click", () => {
      dialog.close();
    });

    // get the hash from the url
    const active_tm_hash = window.location.hash;

    // check if it matches the link href
    if (showButton.getAttribute("href") === active_tm_hash) {
      dialog.showModal();
    }
  }

  const teamCards = document.querySelectorAll(".team-member-card");

  teamCards.forEach((tc) => {
    TeamCard(tc);
  });
}
